import { Typography } from "@mui/material";
import { useGetCurrentRequestActivityBySwarmIdQuery } from "@/services/requestActivityApi";

/**
 * API Response Type for Request Activity
 * @typedef {Object} SwarmResume
 * @property {number} id - Activity ID
 * @property {number} buyManagerId - Buy Manager ID
 * @property {number} eventId - Event ID
 * @property {string} createdOn - Creation date
 * @property {boolean} isNow - Is now flag
 * @property {string} salesDate - Sales date
 * @property {string} modifiedOn - Last modification date
 * @property {Object} accepted - Accepted requests
 * @property {number} accepted.br - Number of accepted buy requests
 * @property {number} accepted.tickets - Number of accepted tickets
 * @property {Object} rejected - Rejected requests
 * @property {number} rejected.br - Number of rejected buy requests
 * @property {number} rejected.tickets - Number of rejected tickets
 * @property {Object} lost - Lost requests
 * @property {number} lost.br - Number of lost buy requests
 * @property {number} lost.tickets - Number of lost tickets
 * @property {Object} pending - Pending requests
 * @property {number} pending.br - Number of pending buy requests
 * @property {number} pending.tickets - Number of pending tickets
 * @property {Object|null} other - Other requests
 * @property {Object} completed - Completed requests
 * @property {number} completed.br - Number of completed buy requests
 * @property {number} completed.tickets - Number of completed tickets
 */

export default function PurchaseActivity({ swarm }) {
  const { data: requestActivity, isLoading: isLoadingRequestActivity, error, isError } = useGetCurrentRequestActivityBySwarmIdQuery(swarm.id, { skip: !swarm.id });

  if (isLoadingRequestActivity) {
    return <Typography>Loading activity data...</Typography>;
  }

  if (isError) {
    return (
      <Typography color="error">
        Error loading activity data: {error?.data?.message || error?.error || 'Unknown error occurred'}
      </Typography>
    );
  }

  return (
    <Typography sx={{ fontSize: '14px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
      <strong>Purchase Activity:</strong> <div style={{ width: '16px', color: 'red' }} />
      Bought: <strong>{requestActivity?.completed || 0}</strong> <div style={{ width: '16px' }} />
      Passed: <strong>{requestActivity?.rejected || 0}</strong> <div style={{ width: '16px' }} />
      Lost: <strong>{requestActivity?.lost || 0}</strong> <div style={{ width: '16px' }} />
      Pending: <strong>{requestActivity?.accepted || 0}</strong>
    </Typography>
  );
}